export enum NegotiationStateEnum {
  None,
  Accepted,
  Rejected
}
